import { customerMarketShopfrontApi } from '@envato/foundation-types'
import { ActionCreator } from 'react-redux'
import { ThunkAction } from 'redux-thunk'

import { setSeoMeta } from '../actions/common'
import { reportPageType } from '../analytics'
import { reportProductsImpressions } from '../analytics/resultAnalytics'
import { IRootState } from '../reducers'
import axiosVerbose from '../utils/axios/axiosVerbose'
import { logError } from '../utils/errors'
import { ICommonLocation } from '../utils/location/types'

export enum TypeKeys {
  GET_CATEGORY_PAGE_API_REQUEST = 'GET_CATEGORY_PAGE_API_REQUEST',
  GET_CATEGORY_PAGE_API_SUCCESS = 'GET_CATEGORY_PAGE_API_SUCCESS',
  GET_CATEGORY_PAGE_API_FAIL = 'GET_CATEGORY_PAGE_API_FAIL'
}

export interface IGetCategoryPageApiRequestAction {
  type: TypeKeys.GET_CATEGORY_PAGE_API_REQUEST
}

export interface IGetCategoryPageApiSuccessAction {
  type: TypeKeys.GET_CATEGORY_PAGE_API_SUCCESS
  payload: Readonly<customerMarketShopfrontApi.categoryPage.IResult>
}

export interface IGetCategoryPageApiFailAction {
  type: TypeKeys.GET_CATEGORY_PAGE_API_FAIL
}

export type ActionTypes =
  | IGetCategoryPageApiRequestAction
  | IGetCategoryPageApiSuccessAction
  | IGetCategoryPageApiFailAction

export const blockContainsItems = (block: any) => {
  return block.componentType === 'ItemsBlock' && block.data.length > 0
}

const reportBlocks = (blocks: any[], currentSite: any) => {
  blocks.forEach((block: any) => {
    if (blockContainsItems(block)) {
      reportProductsImpressions({
        items: block.data,
        currentSite,
        itemRankOffset: 1,
        page: 'Category Page',
        section: block.title
      })
    }
  })
}

export const onBeforeCategoryPageView = (): ThunkAction<
  void,
  IRootState,
  void
> => (dispatch, getState) => {
  const blocks = getState().categoryPage.blocks
  const currentSite = getState().common.currentSite

  reportPageType('category')

  reportBlocks(blocks, currentSite)
}

export const fetchCategoryPageData: ActionCreator<
  ThunkAction<Promise<ActionTypes>, IRootState, void>
> = (location: ICommonLocation, apiAppUrlPrefix: string) => {
  return (dispatch, getState) => {
    const { currentSite } = getState().common

    const category =
      location.pathname && location.pathname.replace('/category/', '')

    const requestAction: IGetCategoryPageApiRequestAction = {
      type: TypeKeys.GET_CATEGORY_PAGE_API_REQUEST
    }

    dispatch(requestAction)

    return axiosVerbose
      .get<any>(
        `${apiAppUrlPrefix}/shopfront-api/category_page/${currentSite}/${category}`
      )
      .then(response => {
        if (response.data.metadata) {
          dispatch(setSeoMeta(response.data.metadata))
        }

        const action: IGetCategoryPageApiSuccessAction = {
          payload: response.data,
          type: TypeKeys.GET_CATEGORY_PAGE_API_SUCCESS
        }
        return dispatch(action)
      })
      .catch(err => Promise.reject(logError(err)))
      .catch(() => {
        const action: IGetCategoryPageApiFailAction = {
          type: TypeKeys.GET_CATEGORY_PAGE_API_FAIL
        }
        return dispatch(action)
      })
  }
}
